<i18n src="@/locales/modules/DeviceTranslate.json"></i18n>

<template>
	<el-dialog
		append-to-body
		destroy-on-close
		:before-close="
			setDialogHide => {
				handleCloseDialog(setDialogHide, isFormDirty);
			}
		"
		class="custom-dialog"
		:visible.sync="isPopupActiveLocal"
	>
		<div slot="title">
			<h4 class="uppercase font-bold block text-xl w-full">{{ $t(id ? "UpdateKpis" : "CreateKpis") }}</h4>
			<p class="text-base text-black font-medium">{{ data && data.device ? data.device.name : "" }}</p>
		</div>
		<PerfectScrollbar ref="formScrollBar" class="scroll-area--data-list" :settings="settings">
			<div class="p-6">
				<div class="mb-4">
					<!-- NAME -->
					<label for class="vs-input--label"> {{ $t("Title") }} <span class="text-danger">*</span>: </label>
					<vs-input :data-vv-as="$t('RemindWork')" :placeholder="`${$t('Actions.Input')} tên ${$t('RemindWork')}`" v-model="name" class="w-full" name="name" v-validate="'required'" />
					<span class="text-danger text-sm break-normal" v-show="errors.has('name')">{{ errors.first("name") }}</span>
				</div>
				<!-- MaintainHour -->
				<div class="mb-5">
					<label for class="vs-input--label"> {{ $t("MaintainHour") }} <span class="text-danger">*</span>: </label>
					<cbs-input
						type="number"
						v-model="maintainHrs"
						class="w-full"
						min="0"
						name="maintainHrs"
						:placeholder="`${$t('Actions.Input')} ${$t('MaintainHour')}`"
						v-validate="{ numeric: true, min_value: 0, required: true }"
						:data-vv-as="$t('MaintainHour')"
					/>
					<span class="text-danger text-sm break-normal" v-show="errors.has('maintainHrs')">{{ errors.first("maintainHrs") }}</span>
				</div>

				<CbsTags v-model="tags" :multiple="false" :title="$t('BelongToGroup')" :placeholder="$t('Group').toLowerCase()" />
			</div>
		</PerfectScrollbar>

		<div class="flex justify-center" slot="footer">
			<vs-button :type="data && data.id ? 'filled' : 'border'" class="w-full sm:w-1/3 mb-3 sm:mb-0 sm:mr-6 font-bold" @click.stop="submitData(data ? !!data.id : false)">
				{{ data && data.id ? $t("Actions.Save") : $t("Actions.SaveAndRecreate") }}
			</vs-button>
			<vs-button v-show="data && !data.id" class="w-full sm:w-1/3 font-bold" @click.stop="submitData">{{ $t("Actions.Submit") }}</vs-button>
		</div>
	</el-dialog>
</template>

<script>
import _ from "lodash";
import CbsTags from "@/components/cbs-tags/CbsTags";
import vSelect from "vue-select";

export default {
	props: {
		isPopupActive: {
			type: Boolean,
			required: true
		},
		data: {
			type: Object,
			default: () => {}
		}
	},
	components: { CbsTags, vSelect },
	data() {
		return {
			ref: "__createnewKpi",
			id: null,
			name: "",
			// kpi: null,

			initFormData: {},
			isFormDirty: false,

			settings: {
				// perfectscrollbar settings
				maxScrollbarLength: 60,
				wheelSpeed: 0.6
			},
			files: [],
			maintainHrs: "",
			tags: []
		};
	},
	watch: {
		isPopupActive(val) {
			if (!val) return;

			const { id, name, maintain_hrs, tags } = this.data;
			if (!this.data.id) {
				this.initValues();
			} else {
				this.id = id;
				this.name = name;
				this.maintainHrs = maintain_hrs && maintain_hrs > 0 ? maintain_hrs : "";
				this.tags = tags && tags[0] ? tags[0].id : null;
				// this.kpi = { id: id, name };
			}

			this.isFormDirty = false;
			this.initFormData = {
				id: this.id,
				name: this.name,
				maintainHrs: this.maintainHrs,
				tags: this.tags
				// kpi: this.kpi
			};
		},
		computedFormData: {
			handler: function(newVal) {
				if (!this.isFormDirty && !_.isEqual(newVal, this.initFormData) && newVal.id === this.initFormData.id) {
					this.isFormDirty = true;
				}
			},
			deep: true
		}
	},
	methods: {
		initValues() {
			if (this.data.id) return;
			this.id = null;
			this.name = "";
			this.maintainHrs = "";
			this.tags = [];
			// this.kpi = null;
			this.$validator.reset();
		},
		handleCreateOrUpdateSuccess(isCloseForm) {
			this.initValues();
			if (isCloseForm) {
				this.$emit("closePopup");
			}
			this.isFormDirty = false;
			this.$helper.notifySuccess({
				context: this,
				options: {
					text: this.$t(`${this.id ? "UpdateKpiSuccessful" : "CreateKpiSuccessful"}`)
				}
			});
		},
		async handleCreateOrUpdateKpi(dataObj, isCloseForm) {
			try {
				this.$vs.loading();
				if (this.data.pivot_id) {
					await this.$store.dispatch("deviceManagement/updateKpiv2ToObject", {
						...dataObj,
						pivot_id: this.data.pivot_id,
						kpi_v2_id: this.data.id
					});
				} else {
					await this.$store.dispatch("deviceManagement/addKpiv2ToObject", {
						...dataObj
					});
				}

				this.handleCreateOrUpdateSuccess(isCloseForm);
			} catch (error) {
				this.$helper.notifyError({ context: this, error });
			} finally {
				this.$vs.loading.close();
			}
		},
		submitData(isCloseForm = false) {
			this.$validator.validateAll().then(result => {
				if (result) {
					const dataObj = {
						maintain_hrs: Number(this.maintainHrs),
						kpiable_type: this.$constant.KPIV2.KPIABLE_TYPE.DEVICE,
						kpiable_id: this.data.device.id,
						name: this.name,

						tag_ids: [this.tags]
					};
					console.log("SUB MMMMM", dataObj);
					this.handleCreateOrUpdateKpi(dataObj, isCloseForm);
				}
			});
		}
	},
	computed: {
		isPopupActiveLocal: {
			get() {
				return this.isPopupActive;
			},
			set(val) {
				if (!val) {
					this.$emit("closePopup");
				}
			}
		},
		computedFormData() {
			return {
				id: this.id,
				name: this.name,
				files: this.files,
				maintainHrs: this.maintainHrs,
				tags: this.tags
				// kpi: this.kpi
			};
		}
	},
	created() {}
};
</script>
